import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class SubPartFService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  saveSubPartFDetails(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData || !data?.rowData?.COMBINATION_KEY) {
      return of({ callSuccess: '0', errorMessage: 'Invalid row data.' });
    }

    const row = data.rowData;
    const jsonObjData = [
      [{ TRANS_DETAILS_KEY: row.NON_SUBF_SERVICE_TRANS_DETAILS_KEY, ACCT_KEY: row.NON_SUBF_SERVICE_ACCT_KEY, BASKET_VALUE: row.CY_NON_SUB_F_SERVICES }],
      [{ TRANS_DETAILS_KEY: row.NON_SUBF_SALES_TRANS_DETAILS_KEY, ACCT_KEY: row.NON_SUBF_SALES_ACCT_KEY, BASKET_VALUE: row.CY_NON_SUB_F_SALES }],
      [{ TRANS_DETAILS_KEY: row.PHY_MANU_TRANS_DETAILS_KEY, ACCT_KEY: row.PHY_MANU_ACCT_KEY, BASKET_VALUE: row.PHYSICAL_MANUFACTURING }],
      [{ TRANS_DETAILS_KEY: row.SAME_COUNTRY_MANU_TRANS_DETAILS_KEY, ACCT_KEY: row.SAME_COUNTRY_MANU_ACCT_KEY, BASKET_VALUE: row.SAME_COUNTRY_MANUFACTURING }],
      [{ TRANS_DETAILS_KEY: row.SUBSTN_CONTRIBUTION_TRANS_DETAILS_KEY, ACCT_KEY: row.SUBSTN_CONTRIBUTION_ACCT_KEY, BASKET_VALUE: row.SUBSTANTIAL_CONTRIBUTION }],
      [{ TRANS_DETAILS_KEY: row.SAME_COUNTRY_SALES_TRANS_DETAILS_KEY, ACCT_KEY: row.SAME_COUNTRY_SALES_ACCT_KEY, BASKET_VALUE: row.SAME_COUNTRY_SALES_USE }],
      [{ TRANS_DETAILS_KEY: row.BRANCH_TRANS_DETAILS_KEY, ACCT_KEY: row.BRANCH_ACCT_KEY, BASKET_VALUE: row.BRANCH }],
      [{ TRANS_DETAILS_KEY: row.AGRI_COMMODITIES_TRANS_DETAILS_KEY, ACCT_KEY: row.AGRI_COMMODITIES_ACCT_KEY, BASKET_VALUE: row.AGRICULTURAL_COMMODITIES }],
      [{ TRANS_DETAILS_KEY: row.OTHERS_TRANS_DETAILS_KEY, ACCT_KEY: row.OTHERS_ACCT_KEY, BASKET_VALUE: row.OTHERS }]
    ];

    const jsonSettings = [{
      tax_year: filterParams?.tax_year,
      ISSUE_KEY: row.ISSUE_KEY
    }];
    const params = _.merge({}, globalService?.globalParams || globalService || {}, filterParams, {
      jsonSettings: JSON.stringify(jsonSettings),
      jsonObj: JSON.stringify(jsonObjData),
      combination_key: row.COMBINATION_KEY,
      jcd_key: globalService?.globalParams?.jcd_key || 250,
      process_name: 'Non-subpartF',
      subpartf_activity: `${row.MANUFACTURING || 0}${row.RESELLING || 0}${row.PROVIDING_SERVICES || 0}${row.OTHER || 0}`
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=uwacqr`,
      params,
      globalService,
      filterParams
    );
  }

  saveSubPartF(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData || !data?.rowData?.COMBINATION_KEY) {
      return of({ callSuccess: '0', errorMessage: 'Invalid row data.' });
    }

    // Legacy parity: subPartFService.js -> factory.saveSubPartF.
    // Match the exact AngularJS guard order and restore-value rules so the
    // grid reverts the edited cell when validation fails.
    const oldValue = (data?.oldRowData == null)
      ? data?.oldValue
      : data.oldRowData[data.col_id];
    const currentValue = data.rowData[data.col_id];

    // No change -> skip without showing any snackbar.
    if (currentValue === oldValue) {
      return of({ callSuccess: '1', skipped: true });
    }

    // Legacy: "You cannot enter null or empty values..."
    const isEmpty =
      currentValue === null ||
      currentValue === undefined ||
      (typeof currentValue === 'string' && currentValue.trim() === '');
    if (isEmpty) {
      // Legacy restore order for empty: oldValue first, then oldRowData.
      data.rowData[data.col_id] =
        data?.oldValue !== undefined ? data.oldValue : data?.oldRowData?.[data.col_id];
      return of({
        callSuccess: '0',
        errorMessage:
          'You cannot enter null or empty values for Subpart F Sales and SubPart F Services, Please enter valid values'
      });
    }

    const row = data.rowData;

    // Legacy: Income accounts can only receive negative adjustments in
    // SUB_F_CY_SALES / SUB_F_CY_SERVICES. Any positive value is rejected
    // and the originally edited cell is reverted.
    if (
      row.TO_ACCT_TYPE_DESC === 'Income' &&
      (Number(row.SUB_F_CY_SALES) > 0 || Number(row.SUB_F_CY_SERVICES) > 0)
    ) {
      // Legacy restore order for this branch: oldRowData first, then oldValue.
      data.rowData[data.col_id] =
        data?.oldRowData != null ? data.oldRowData[data.col_id] : data?.oldValue;
      return of({
        callSuccess: '0',
        errorMessage:
          'Please enter only negative numbers in Subpart F Sales and SubPart F Services columns'
      });
    }

    const jsonObj = JSON.stringify([row]);
    const jsonSettings = JSON.stringify([{
      tax_year: filterParams?.tax_year,
      ISSUE_KEY: globalService?.globalParams?.issue_id === undefined ? null : parseInt(globalService.globalParams.issue_id, 10)
    }]);

    const params = _.merge({}, globalService?.globalParams || globalService || {}, filterParams, {
      jsonObj,
      jsonSettings,
      process_name: 'saveSubPartF'
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_id=130`,
      params,
      globalService,
      filterParams
    );
  }
}
